import { Component, HostListener } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { Observable } from 'rxjs-compat';
import { slideInAnimation } from './animations/animation';
import { PageService } from './services/page.service';
import { ThemeService } from './services/theme.service';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    animations: [slideInAnimation],
    host: { '[@routeAnimations]': '' }
})
export class AppComponent {
    title = 'pullatv-site';
    menuActive: boolean = false;
    touchDevice: boolean = false;
    showButton: boolean = false
    isTouchDevice = /iPhone|iPad|iPod|Android|webOS|BlackBerry|Opera Mini|IEMobile/i.test(navigator.userAgent);
    isIPadPro = /Macintosh/.test(navigator.userAgent) && 'ontouchend' in document;
    screenWidth;
    lastScrollTop;
    whiteLogo: boolean = false;
    outletTransform: number = 0;
    position: string = 'absolute';
    isDarkTheme: Observable<boolean>;
    
    prepareRoute(outlet: RouterOutlet) {
        return outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation;
    }

    constructor(private pageService: PageService,
        private router: Router,
        private themeService: ThemeService) {
        this.pageService.showGoToTopButtonListen().subscribe((resp) => {
            this.showButton = resp;
        })
        this.onResize();
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        if (this.isTouchDevice) {
            this.touchDevice = true;
        } else {
            this.touchDevice = false;
        }
        this.screenWidth = window.innerWidth;
        if (this.screenWidth > 1024) {
            this.outletTransform = 100;
            this.position = 'absolute';
        } else {
            this.outletTransform = 0;
            this.position = 'fixed';
        }
    }

    ngOnInit() {
        this.isDarkTheme = this.themeService.isDarkTheme;
        if (this.screenWidth > 1024) {
            this.outletTransform = 100;
        } else {
            this.outletTransform = 0;
        }
        if (this.isTouchDevice) {
            this.touchDevice = true;
        } else {
            this.touchDevice = false;
        }
    }

    ngAfterViewInit() {
        if (window.location.pathname !== '/') {
            this.pageService.loadPage("");
        }
    }

    @HostListener('window:scroll', ['$event'])
    onScroll(event) {
        var scroll_Top = window.pageYOffset;
        if (scroll_Top > window.innerHeight) {
            this.showButton = true;
        } else {
            this.showButton = false;
        }
        if (this.screenWidth <= 1024) {
            var st = window.pageYOffset || document.documentElement.scrollTop;
            var menu = document.getElementsByClassName('top-bar')[0];
            var logo = document.getElementsByClassName('logo-wrapper')[0];
            var menuIcon = document.getElementsByClassName('toggle-button-container')[0];
            var menuCategories = document.getElementsByClassName('dropdown-list')[0];
            var categoriesCross = document.getElementsByClassName('cross-rotate')[0];
            var backToWorkButton = document.getElementsByClassName('wrapper-button')[0];

            if (st > this.lastScrollTop) {
                menu.classList.add('hide-bar');
                logo.classList.add('hide-logo');
                menuIcon.classList.add('hide-menu');
                backToWorkButton.classList.add('hide-button');
                if (menuCategories.classList.contains('active')) {
                    menuCategories.classList.remove('active');
                    categoriesCross.classList.remove('active');
                }
            } else {
                if (menu.classList.contains('hide-bar') && logo.classList.contains('hide-logo') && menuIcon.classList.contains('hide-menu') && backToWorkButton.classList.contains('hide-button')) {
                    menu.classList.remove('hide-bar');
                    logo.classList.remove('hide-logo');
                    menuIcon.classList.remove('hide-menu');
                    backToWorkButton.classList.remove('hide-button');
                }
            }
            this.lastScrollTop = st <= 0 ? 0 : st;

            if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
                if (this.router.url.indexOf('/works') > -1) {
                    this.pageService.whiteLogo(false);
                    this.whiteLogo = false;
                } else {
                    this.pageService.whiteLogo(true);
                    this.whiteLogo = true;
                }
            } else {
                if (this.whiteLogo) {
                    this.pageService.whiteLogo(false);
                    this.whiteLogo = false;
                }
            }
        }
    }
    goToTop() {
        var element;
        var elementAndroid;
        if (window.location.pathname === '/company') {
            element = document.querySelector('#compnay-container-0');
            elementAndroid = document.getElementById('main-container-wrapper');
        } else if (window.location.pathname === '/reels') {
            element = document.querySelector('#reel-container-0');
            elementAndroid = document.getElementById('main-container-wrapper');
        } else {
            element = document.querySelector('body');
        }

        var userAgent = navigator.userAgent || navigator.vendor;
        if (/android/i.test(userAgent)) {
            if (elementAndroid) {
                elementAndroid.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            } else {
                element.scrollIntoView({ behavior: "smooth" });
            }
        } else {
            element.scrollIntoView({ behavior: "smooth" });
        }
    }
}
